import { useLocation } from '@tanstack/react-router';

import { useGoBack } from '@libs/hooks/useGoBack';
import { useGoHome } from '@libs/hooks/useGoHome';
import { ErrorsNotificationProvider } from '@providers/ErrorsNotificationProvider';
import { ThemeLink } from '@ui/components/ThemeLink';

import { SiteLayoutWidget } from '@features/shared/ui/SiteLayout/SiteLayoutWidget';

import styles from './NotFoundPage.module.css';

type Props = {
  subTitle?: string;
};
export function NotFoundPage({ subTitle = 'Страница не найдена' }: Props) {
  const goBack = useGoBack();
  const location = useLocation();
  const isClubRootPage = location.pathname.match('/club/([^/]+)$');
  const goHome = useGoHome({ preserveClub: !isClubRootPage });

  const clubId = location.pathname.match('/club/([^/]+)/')?.[1];

  return (
    <ErrorsNotificationProvider>
      <SiteLayoutWidget clubId={clubId || ''}>
        <div className={styles.content}>
          <div className={styles.header}>404</div>
          <div className={styles.subTitle}>{subTitle}</div>
          <div className={styles.links}>
            <ThemeLink onClick={goBack}>Назад</ThemeLink>
            <ThemeLink onClick={goHome}>На главную</ThemeLink>
          </div>
        </div>
      </SiteLayoutWidget>
    </ErrorsNotificationProvider>
  );
}
